export function itemListReducer(state = [], action) {
  switch (action.type) {
    case "ADD_TO_LIST":
      return action.payload;
    case "UPDATE_LIST":
      return action.payload;
    case "EMPTY_LIST":
      return action.payload;
    default:
      return state;
  }
}
